// noinspection DuplicatedCode

import { localget, localremove, localset, sessionremove } from 'Utils/storage';
import { getDeviceInfo } from 'CommonUtils/plus';
import { ifStrBlank } from 'Utils/string';
import { parseQueryString } from 'Utils/tools';
import aes from 'Utils/aes';
import consts from 'Utils/consts';

import { Toast } from 'vant';
import {DJKK_CONFIG, GAT_CONFIG, YX_CONFIG} from 'Config/index';
import router from 'Plugins/router';

/**
 * 第三方授权注册函数
 * async function f(queryParams) {
 *    queryParams.channelParam = 'AES加密的json对象'
 * }
 * 注册函数里面有判断逻辑到底要不要执行 不把 channelParam 设置给 queryParams 就不会执行
 * 注意：需要把 channelParam 设置给 queryParams
 * channelParam AES加密的json对象
 */
const RegisterFuncs = [];

export default {
  data() {
    return {
      hasInitRegisterFuncs: false,
    };
  },
  async created() {
    // 标准单点登录
    await this.standardSsoLogin();
    // 第三方授权登录，在具体的组件内部调用
    // await this.auth()
  },
  methods: {
    // 标准单点登录，主要是为了解决oa单点登录时，未触发路由守卫里的登录逻辑 config/interceptors/routers.js:routerBeforeEachFunc
    async standardSsoLogin() {
      let q = parseQueryString(window.location.href);
      if (q && q.loginType && q.loginType == '10' && !q.ssoFirst && q.ssotoken) {
        await this.$router.push({path: this.$route.fullPath, query: {...q, ssoFirst: true}})
      }
    },
    // 注册第三方授权注册函数
    async initThirdRegisterFunc() {
      RegisterFuncs.push(this.gatRegister);
      RegisterFuncs.push(this.yxRegister);
      RegisterFuncs.push(this.djRegister);
      this.hasInitRegisterFuncs = true;
    },
    // 第三方授权登录
    async auth() {
      const loading = Toast({duration: 0, message: '加载中...', forbidClick: true});
      try {
        if (!this.hasInitRegisterFuncs) {
          await this.initThirdRegisterFunc();
        }
        await this.doAuth();
      } catch (e) {
        console.error('初始化登录出错:', e);
        Toast.fail({duration: 10000, message: '初始化登录出错:' + JSON.stringify(e)});
      } finally {
        loading.clear();
      }
    },
    // 第三方授权登录
    async doAuth() {

      // 获取url参数
      const queryParams = parseQueryString(window.location.href);
      if (queryParams.auth_code) {// 确保是关爱通渠道一定保存
        localset(consts.thirdChannelParam, {accessChannel: 'gat'});
      }

      // 调用第三方授权注册函数
      for (let i = 0; i < RegisterFuncs.length; i++) {
        await RegisterFuncs[i].call(this, queryParams);
      }

      // 根据渠道参数进行登录
      if (queryParams.channelParam) {
        const aesKey = queryParams.aesKey || aes.defaultKey;
        const channelParam = JSON.parse(aes.decrypt(decodeURIComponent(queryParams.channelParam), aesKey));

        // 检验参数
        if (ifStrBlank(channelParam.loginName) || ifStrBlank(channelParam.accessChannel)) {
          this.$toast('初始化用户信息失败，请您退出重试');
          return;
        }

        // 保存渠道参数
        localStorage.setItem(consts.fromSource, JSON.stringify(channelParam));
        this.channelParam = channelParam;

        // 针对已登录的用户，并且开启了登录检测，不再登录
        if (queryParams.enableLoginCheck && (channelParam.isLogin || queryParams.isLogin)) {
          return;
        }
        // 实际登录逻辑
        await this.doLogin(queryParams, channelParam);
      }
    },
    // 登录逻辑
    async doLogin(queryParams, channel) {
      // 登录参数
      const params = {
        account: '', //不知
        compId: channel.companyId,
        corpId: channel.corpId,
        loginName: channel.loginName, //手机号
        deviceShortname: getDeviceInfo().deviceShortname, //设置型号
        deviceId: getDeviceInfo().deviceId, //设备标识
        autologinType: channel.loginType || 2, //(integer, optional): 登陆方式,1-自动登录2-手动登录
        loginWay: 4,// 1-密码登录 2-验证码 3-注册4-第三方跳转
        password: channel.password,// 密码
        openId: '',
        doNotRedirect: queryParams.doNotRedirect || false,
      };
      // 清除登录状态
      await this.clearLoginState();
      // 登录接口
      await this.$store.dispatch('login', params);
      // 保存渠道参数，不论实际登录成功与否
      localset(consts.thirdChannelParam, channel);
      // 登录成功后，保存渠道参数
      let isLogin = await this.checkLoginState();
      if (isLogin) {
        if (queryParams.afterLogin && typeof queryParams.afterLogin === 'function') {
          queryParams.afterLogin();
        }
      }
    },
    // 检测登录状态
    async checkLoginState() {
      const token = localget('access_token');
      return token && token.length >= 32;
    },
    // 清除登录状态
    async clearLoginState() {
      // sessionremove('VUEX_STATE')
      // localremove('VUEX_STATE')
      localremove('userInfo');
      localremove('access_token');
    },
    // 关爱通跳转授权注册
    async gatRegister(queryParams) {

      // 检验是否关爱通授权码跳转过来的
      // https://app.tmc.tianxiapiao.cn/#/tk/tkQuery?auth_code=xxx
      if (!queryParams || !queryParams.auth_code) {
        localset('notlogGAT', '');
        return;
      }

      // 获取授权码
      queryParams.aesKey = aes.gatKey;

      // 调关爱通授权注册接口
      const params = {
        authCode: queryParams.auth_code,
        corpId: GAT_CONFIG.gatCorpId,
      };

      // 调后端关爱通授权注册接口
      localset('notlogGAT', '关爱通');
      let result;
      try {
        result = await this.$api['user/userRegister4Gat'](params);
      } catch (ignore) {// 接口异常无需处理程序会自动处理
        console.error('关爱通授权注册失败: 100', ignore);
        return;
      } finally {
        // 不管成功失败都要设置渠道参数，若登录成功，会覆盖此参数
        // 无论如何都要设置渠道参数，以确定是关爱通授权码跳转过来的
        localset(consts.thirdChannelParam, {accessChannel: 'gat'});
      }

      const {data} = result;
      if (data.code !== '200') {
        console.error('关爱通授权注册失败:', data);
        Toast.fail({duration: 5000, message: `授权失败：${data.code}`});
        return;
      }

      // 渠道参数
      if (data.channelParam) {
        queryParams.channelParam = data.channelParam;
        queryParams.enableLoginCheck = false;// 关闭登录检测
        queryParams.doNotRedirect = true;// 不跳转
        queryParams.afterLogin = function () {
          router.replace({path: '/home'});
        }
      } else {
        console.error('关爱通授权注册失败:', data);
        Toast.fail({duration: 5000, message: '授权失败：101'});
      }
    },
    // 研学
    async yxRegister(queryParams) {

      // 通过url参数判断是否是研学跳转过来的
      // https://app.tmc.tianxiapiao.cn/#/tk/tkQuery?accessChannel=yx&channelParam=xxx
      // channelParam = AES加密的json对象
      // channelParam = {
      //    accessChannel: 'yx',
      //    openId: '手机号',
      //    name: '昵称',
      // }
      if (queryParams.yxIsLogin || !queryParams || !queryParams.accessChannel || queryParams.accessChannel !== 'yx' || !queryParams.channelParam) {
        return;
      }

      const reqParam = JSON.parse(aes.decrypt(decodeURIComponent(queryParams.channelParam), YX_CONFIG.yxAesKey));
      if (reqParam.accessChannel !== 'yx') {
        return;
      }
      // 清除登录状态
      queryParams.yxIsLogin = false;
      // 调研学授权注册接口
      const params = {
        openId: reqParam.openId,
        name: reqParam.name,
        corpId: YX_CONFIG.yxCorpId,
      };

      // 调后端研学授权注册接口
      let result;
      try {
        result = await this.$api['user/userRegister4Yx'](params);
      } catch (ignore) {// 接口异常无需处理程序会自动处理
        console.error('研学授权注册失败: 100', ignore);
        return;
      } finally {
        // 不管成功失败都要设置渠道参数，若登录成功，会覆盖此参数
        // 无论如何都要设置渠道参数，以确定是研学跳转过来的
        localset(consts.thirdChannelParam, {accessChannel: 'yx'});
      }

      const {data} = result;
      if (data.code !== '200') {
        console.error('研学授权注册失败:', data);
        Toast.fail({duration: 5000, message: `授权失败：${data.code}`});
        return;
      }

      // 渠道参数
      if (!data.channelParam) {
        console.error('研学授权注册失败:', data);
        return Toast.fail({duration: 5000, message: '授权失败：101'});
      }

      queryParams.channelParam = data.channelParam;
      queryParams.doNotRedirect = true;// 不跳转
      queryParams.aesKey = YX_CONFIG.yxAesKey;
      const param = JSON.parse(aes.decrypt(decodeURIComponent(queryParams.channelParam), YX_CONFIG.yxAesKey));
      if (param.isLogin) {
        queryParams.enableLoginCheck = true;
        const token = param.token;
        localset('AutoLogin', param)
        await this.$store.commit('SET_TOKEN', token)
        await this.$store.dispatch('getUserInfo')
        queryParams.yxIsLogin = true;
      }
    },
    // 大江看看跳转授权注册
    async djRegister(queryParams) {
      // 检验是否大江看看跳转过来的
      // https://app.tmc.tianxiafen.com/#/home?corpId=0799011dd98649979c1aeb94557c275a&hideTopView=1&showStatusBar=1&accessChannel=djkk
      if (queryParams.djkkIsLogin || !queryParams || !queryParams.accessChannel || queryParams.accessChannel !== 'djkk') {
        return;
      }
      if (!window.SmartCity) {
        console.error('SmartCity SDK 未加载')
        Toast.fail({duration: 5000, message: '缺失必要引用，操作失败'});
        return;
      }
      console.log('djkk.SmartCity：', window.SmartCity);
      if (!window.SmartCity.isSmartCityApp()) {
        console.error("SmartCity App 中打开此功能");
        Toast.fail({duration: 5000, message: '缺失必要环境，操作失败'});
        return;
      }
      // 校验结束

      // 清除登录状态
      queryParams.djkkIsLogin = false;
      // 调tmc大江看看单点登陆注册接口
      let result;
      try {
        // 大江看看APP-JS-SDK获取用户信息
        const params = await this.getDjkkUserInfo();
        console.log('tmc大江看看单点登陆注册接口入参before：', params)
        params.corpId = queryParams.corpId;
        console.log('tmc大江看看单点登陆注册接口入参after：', params)

        result = await this.$api['user/userRegister4Djkk'](params);
        console.log('tmc大江看看单点登陆注册接口：', result)
      } catch (ignore) {
        console.error('大江看看APP用户授权注册失败', ignore);
        return;
      } finally {
        localset(consts.thirdChannelParam, {accessChannel: 'djkk'});
      }
      const {data} = result;
      if (data.code !== '200') {
        console.error('大江看看APP用户授权注册失败:', data);
        Toast.fail({duration: 5000, message: `授权失败：101`});
        return;
      }
      // 渠道参数
      if (data.channelParam) {
        queryParams.channelParam = data.channelParam;
        queryParams.doNotRedirect = true;// 不跳转
        queryParams.aesKey = DJKK_CONFIG.djkkAesKey;
        const param = JSON.parse(aes.decrypt(decodeURIComponent(queryParams.channelParam), DJKK_CONFIG.djkkAesKey));
        if (param.isLogin) {
          queryParams.enableLoginCheck = true;
          const token = param.token;
          localset('AutoLogin', param)
          await this.$store.commit('SET_TOKEN', token)
          await this.$store.dispatch('getUserInfo')
          queryParams.djkkIsLogin = true;
        }
      } else {
        console.error('大江看看APP用户授权注册失败:', data);
        Toast.fail({duration: 5000, message: '授权失败：101'});
      }
    },
    // 大江看看APP获取用户信息
    async getDjkkUserInfo() {
      return new Promise((resolve, reject) => {
        window.SmartCity.getUserInfo(function(res) {
          console.log('大江看看APP获取用户信息返回：', res);
          if (res && res.userInfo) {
            console.log('大江看看APP获取用户信息成功，给tmc单点登陆接口赋值：', res.userInfo)
            resolve({
              phone: res.userInfo.telephone,
              userId: res.userInfo.userid,
            });
          } else {
            console.error('SmartCity SDK getUserInfo 获取用户信息异常');
            reject(new Error('获取用户信息失败'));
          }
        });
      });
    }
  }
};
